import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import allAPI from "../../api/api";
import { jwtDecode } from "jwt-decode";

const initialState = {
  user: null,
  loading: false,
  error: null,
   errorotpForResetPassword: null,
  errorverifyOtp: null,
  errorresetPassword: null,
  errorSetPassword: null,
  token: null,
  slice: "new",

  emailValue: "",
  passwordValue: "",
  showOtpScreen: false,
  showResetPwdScreen: false,
};

// Async thunk for logging in
export const login = createAsyncThunk(
  "auth/login",
  async ({ email, password }, { rejectWithValue }) => {
    console.log("came inside login")
    try {
      console.log("came inside try of login")
      const response = await allAPI.auth.login({ email, password });
      if (response.status === 200 || response.status === 201) {
        // Validate response contains expected data
        if (!response.data || !response.data.email) {
          return rejectWithValue({ message: "Invalid server response" });
        }
        return response.data;
      } else {
        return rejectWithValue({ message: `Unexpected status code: ${response.status}` });
      }
    } catch (error) {
      console.error("Login failed:", error);
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);

export const loginOTP = createAsyncThunk(
  "auth/loginOTP",
  async ({ email, password, otpValue }, { rejectWithValue }) => {
    try {
      const CONSTANT = {}
      const version = Math.random().toString(36).substring(2, 15);
      Object.assign(CONSTANT, { version });

      const response = await allAPI.auth.loginOTP({ email, password, otpValue, version });
      if (response.status === 200 || response.status === 201) {
        if (response.data?.version && response.data.version !== version) {
          return rejectWithValue({ message: "Authentication failed: version mismatch" });
        }
        if (!response.data || !response.data.success || !response.data.user) {
          return rejectWithValue({ message: "Authentication failed: Invalid server response" });
        }
        return response.data;
      } else {
        return rejectWithValue({ message: `Unexpected status code: ${response.status}` });
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);

// Async thunk for logging out
export const logout = createAsyncThunk(
  "auth/logout",
  async (_, { rejectWithValue }) => {
    try {
      console.log("logged out")
      const response = await allAPI.auth.logout();
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("Logout failed:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Get current user from HTTP-only cookie
export const getCurrentUser = createAsyncThunk(
  "auth/getCurrentUser",
  async (_, { rejectWithValue }) => {
    try {
      const response = await allAPI.auth.getCurrentUser();
      if (response.status === 200 || response.status === 201) {
        return response.data;
      } else {
        return rejectWithValue(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("Get current user failed:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const otpForResetPassword = createAsyncThunk(
  "auth/otpForResetPassword",
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const response = await allAPI.auth.otpForResetPassword({ email, password });
      if (response.status === 201 || response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data || `Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("Login failed with error:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const verifyOtp = createAsyncThunk(
  "auth/verifyOtp",
  async ({ email, otpValue }, { rejectWithValue }) => {
    try {
      const response = await allAPI.auth.verifyOtp({ email, otpValue });
      if (response.status === 201) {
        return response.data;
      } else {
        return rejectWithValue(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("Login failed:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async ({ email,otpValue, newPassword }, { rejectWithValue }) => {
    try {
      const response = await allAPI.auth.resetPassword({ email,otpValue, newPassword });
      if (response.status === 201) {
        return response.data;
      } else {
        return rejectWithValue(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("Login failed:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const onboardingSetNewPassword = createAsyncThunk(
  "auth/onboardingSetNewPassword",
  async ({ userId, newPassword }, { rejectWithValue }) => {
    try {
      const response = await allAPI.auth.onboardingSetNewPassword(
        userId,
        { newPassword }
      );
      if (response.status === 200 || response.status === 201) {
        return response.data;
      } else {
        return rejectWithValue(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error("Set new password failed:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setEmailValue: (state, action) => {
      state.emailValue = action.payload;
    },
    setPasswordValue: (state, action) => {
      state.passwordValue = action.payload;
    },
    setShowOtpScreenValue: (state, action) => {
      state.showOtpScreen = action.payload;
    },
    setShowResetPwdScreenValue: (state, action) => {
      state.showResetPwdScreen = action.payload;
    },
    clearAuthError: (state) => {
    state.error = null;
  },
  },
  extraReducers: (builder) => {
    builder
      // .addCase(login.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(login.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.user = action.payload;
      // })
      // .addCase(login.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.payload;
      // })
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(logout.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(logout.fulfilled, (state) => {
        state.loading = false;
        state.user = null;
      })
      .addCase(logout.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // loginOTP
      .addCase(loginOTP.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginOTP.fulfilled, (state, action) => {
        state.loading = false;
        // Validate response has success flag and user data
        if (!action.payload?.success || !action.payload?.user) {
          state.error = { message: "Authentication failed: Invalid server response" };
          state.token = null;
          state.user = null;
          localStorage.removeItem('login');
          localStorage.removeItem('authenticated');
          return;
        }
        
        // Store user data (NOT token) for UI
        state.user = action.payload.user;
        state.token = null; // Never store the token
        
        // Set authentication flags
        localStorage.setItem('login', JSON.stringify(true));
        localStorage.setItem('authenticated', JSON.stringify(true));
        
        console.log("Authentication successful - user data stored, token in HTTP-only cookie");
      })
      .addCase(loginOTP.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        // Ensure no authentication data is stored on OTP failure
        state.token = null;
        state.user = null;
        localStorage.removeItem('login');
        localStorage.removeItem('authenticated');
      })

      // otpForResetPassword
      .addCase(otpForResetPassword.pending, (state) => {
        state.loading = true;
        state.errorotpForResetPassword = null;
      })
      .addCase(otpForResetPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.errorotpForResetPassword = null;
      })
      .addCase(otpForResetPassword.rejected, (state, action) => {
        state.loading = false;
        state.errorotpForResetPassword = action.payload || action.error?.message || 'Failed to request OTP for password reset.';
      })

      // verifyOtp
      .addCase(verifyOtp.pending, (state) => {
        state.loading = true;
        state.errorverifyOtp = null;
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.errorverifyOtp = null;
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.loading = false;
        state.errorverifyOtp = action.payload || action.error?.message || 'OTP verification failed.';
      })

      // resetPassword
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
        state.errorresetPassword = null;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.errorresetPassword = null;
        state.passwordValue = '';
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.errorresetPassword = action.payload || action.error?.message || 'Password reset failed.';
      })
      
      .addCase(onboardingSetNewPassword.pending, (state) => {
        state.loading = true;
        state.errorSetPassword = null;
      })
      .addCase(onboardingSetNewPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.errorSetPassword = null;
      })
      .addCase(onboardingSetNewPassword.rejected, (state, action) => {
        state.loading = false;
        state.errorSetPassword = action.payload || action.error?.message || 'Set password failed.';
      })
      // getCurrentUser
      .addCase(getCurrentUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCurrentUser.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.user) {
          state.user = action.payload.user;
        }
      })
      .addCase(getCurrentUser.rejected, (state, action) => {
        state.loading = false;
        // Clear authentication on failure
        state.user = null;
        state.token = null;
        localStorage.removeItem('login');
        localStorage.removeItem('authenticated');
      })
  },
});

export const { clearError, setEmailValue,
  setPasswordValue,
  setShowOtpScreenValue,clearAuthError,setShowResetPwdScreenValue } = authSlice.actions;

export default authSlice.reducer;
